import { render, staticRenderFns } from "./MtsTakipHazirlaBetaIslemDetayView.vue?vue&type=template&id=3447486d&scoped=true"
import script from "./MtsTakipHazirlaBetaIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./MtsTakipHazirlaBetaIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3447486d",
  null
  
)

export default component.exports